import * as React from 'react';

import styles from './PageLayout.module.css';

const PageLayout = ({children}) => {
  return (
    <div id="layout" className={styles.pageLayout}>
      {children}
    </div> 
  );
};

export default PageLayout;